import styled from 'styled-components'
import above from '@/utils/above'
import getColumnSize from '@/utils/getColumnSize'
import * as UI from '@/components/UI'

export const Section = styled.section`
  background: ${p => p.theme.colors.snow};
  ${above('lg')`
    background: linear-gradient(
      180deg,
      ${p => p.theme.colors.snow} 0%,
      ${p => p.theme.colors.flash} 100%
    );
    padding: 5rem 0;
  `}
`

export const Grid = styled(UI.Grid)`
  align-items: center;
  position: relative;
  ${p =>
    p.inverted &&
    above('lg')`
    flex-direction: row-reverse;
  `}
`

export const GalleryCell = styled.div`
  margin-left: -8px;
  width: 100vw;
  padding: 0;
  ${above('md')`
    width: 100%;
    margin: 0;
  `}
  ${above('lg')`
    width: ${getColumnSize(6)};
    & > * {
      margin-${p => (p.inverted ? 'right' : 'left')}: calc(-50vw + 100% + 1rem);
    }
  `}
`

export const TestimonialsCell = styled.div`
  width: ${getColumnSize(12)};
  margin-top: 5rem;
  margin-bottom: 5rem;
  ${above('sm')`
    width: ${getColumnSize(10)};
    margin-${p => (p.inverted ? 'right' : 'left')}: ${getColumnSize(1)};
  `}
  ${above('md')`
    width: ${getColumnSize(8)};
    margin: 5rem ${getColumnSize(2)};
  `}
  ${above('lg')`
    width: ${getColumnSize(6)};
    margin: 0;
  `}
  ${above('xg')`
    margin-${p => (p.inverted ? 'right' : 'left')}: ${getColumnSize(1)};
    width: ${getColumnSize(5)};
  `}
`
